var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.aloading),expression:"aloading"}],staticClass:"contnet"},[_c('p',{staticClass:"doneBtn",on:{"click":_vm.clickDone}},[_vm._v("点击完成授权")])])
}
var staticRenderFns = []

export { render, staticRenderFns }